const BRAND_STATUSES = {
  VERIFIED: {
    value: 'VERIFIED',
    label: 'verified',
  },
  UNVERIFIED: {
    value: 'UNVERIFIED',
    label: 'unverified',
  },
  UNKNOWN: {
    value: 'UNKNOWN',
    label: 'unknown',
  },
  SELF_DECLARED: {
    value: 'SELF_DECLARED',
    label: 'self declared',
  },
  VETTED_VERIFIED: {
    value: 'VETTED_VERIFIED',
    label: 'vetted verified',
  },
};

const BUSINESS_ID_TYPES = {
  DUNS: {
    value: 'DUNS',
    label: 'brands.businessIdTypeOptions.DUNS',
  },
  GIIN: {
    value: 'GIIN',
    label: 'brands.businessIdTypeOptions.GIIN',
  },
  LEI: {
    value: 'LEI',
    label: 'brands.businessIdTypeOptions.LEI',
  },
  NONE: {
    value: 'NONE',
    label: 'brands.businessIdTypeOptions.NONE',
  },
};

const ENTITY_TYPES = {
  PRIVATE_PROFIT: {
    value: 'PRIVATE_PROFIT',
    label: 'brands.entityTypeOptions.PRIVATE_PROFIT',
  },
  PUBLIC_PROFIT: {
    value: 'PUBLIC_PROFIT',
    label: 'brands.entityTypeOptions.PUBLIC_PROFIT',
  },
  NON_PROFIT: {
    value: 'NON_PROFIT',
    label: 'brands.entityTypeOptions.NON_PROFIT',
  },
  GOVERNMENT: {
    value: 'GOVERNMENT',
    label: 'brands.entityTypeOptions.GOVERNMENT',
  },
};

const STOCK_EXCHANGE_TYPES = {
  AMEX: {
    value: 'AMEX',
    label: 'brands.stockExchangeOptions.AMEX',
  },
  AMX: {
    value: 'AMX',
    label: 'brands.stockExchangeOptions.AMX',
  },
  ASX: {
    value: 'ASX',
    label: 'brands.stockExchangeOptions.ASX',
  },
  B3: {
    value: 'B3',
    label: 'brands.stockExchangeOptions.B3',
  },
  BME: {
    value: 'BME',
    label: 'brands.stockExchangeOptions.BME',
  },
  // BMV: {
  //   value: 'BMV',
  //   label: 'brands.stockExchangeOptions.BMV',
  // },
  BSE: {
    value: 'BSE',
    label: 'brands.stockExchangeOptions.BSE',
  },
  FRA: {
    value: 'FRA',
    label: 'brands.stockExchangeOptions.FRA',
  },
  ICEX: {
    value: 'ICEX',
    label: 'brands.stockExchangeOptions.ICEX',
  },
  // IDX: {
  //   value: 'IDX',
  //   label: 'brands.stockExchangeOptions.IDX',
  // },
  // JPX: {
  //   value: 'JPX',
  //   label: 'brands.stockExchangeOptions.JPX',
  // },
  JSE: {
    value: 'JSE',
    label: 'brands.stockExchangeOptions.JSE',
  },
  KRX: {
    value: 'KRX',
    label: 'brands.stockExchangeOptions.KRX',
  },
  LON: {
    value: 'LON',
    label: 'brands.stockExchangeOptions.LON',
  },
  // LSE: {
  //   value: 'LSE ',
  //   label: 'brands.stockExchangeOptions.LSE',
  // },
  // MISX: {
  //   value: 'MISX',
  //   label: 'brands.stockExchangeOptions.MISX',
  // },
  // MOEX: {
  //   value: 'MOEX',
  //   label: 'brands.stockExchangeOptions.MOEX',
  // },
  NASDAQ: {
    value: 'NASDAQ',
    label: 'brands.stockExchangeOptions.NASDAQ',
  },
  NSE: {
    value: 'NSE',
    label: 'brands.stockExchangeOptions.NSE',
  },
  NYSE: {
    value: 'NYSE',
    label: 'brands.stockExchangeOptions.NYSE',
  },
  OMX: {
    value: 'OMX',
    label: 'brands.stockExchangeOptions.OMX',
  },
  SEHK: {
    value: 'SEHK',
    label: 'brands.stockExchangeOptions.SEHK',
  },
  // SET: {
  //   value: 'SET',
  //   label: 'brands.stockExchangeOptions.SET',
  // },
  // SGX: {
  //   value: 'SGX',
  //   label: 'brands.stockExchangeOptions.SGX',
  // },
  // SIX: {
  //   value: 'SIX',
  //   label: 'brands.stockExchangeOptions.SIX',
  // },
  SSE: {
    value: 'SSE',
    label: 'brands.stockExchangeOptions.SSE',
  },
  STO: {
    value: 'STO',
    label: 'brands.stockExchangeOptions.STO',
  },
  SWX: {
    value: 'SWX',
    label: 'brands.stockExchangeOptions.SWX',
  },
  SZSE: {
    value: 'SZSE',
    label: 'brands.stockExchangeOptions.SZSE',
  },
  TSX: {
    value: 'TSX',
    label: 'brands.stockExchangeOptions.TSX',
  },
  TWSE: {
    value: 'TWSE',
    label: 'brands.stockExchangeOptions.TWSE',
  },
  VSE: {
    value: 'VSE',
    label: 'brands.stockExchangeOptions.VSE',
  },
  NONE: {
    value: 'NONE',
    label: 'brands.stockExchangeOptions.NONE',
  },
};

const VERTICALS = {
  REAL_ESTATE: {
    value: 'REAL_ESTATE',
    label: 'brands.verticalOptions.realEstate',
  },
  HEALTHCARE: {
    value: 'HEALTHCARE',
    label: 'brands.verticalOptions.healthcare',
  },
  ENTERTAINMENT: {
    value: 'ENTERTAINMENT',
    label: 'brands.verticalOptions.entertainment',
  },
  RETAIL: {
    value: 'RETAIL',
    label: 'brands.verticalOptions.retail',
  },
  AGRICULTURE: {
    value: 'AGRICULTURE',
    label: 'brands.verticalOptions.agriculture',
  },
  INSURANCE: {
    value: 'INSURANCE',
    label: 'brands.verticalOptions.insurance',
  },
  HOSPITALITY: {
    value: 'HOSPITALITY',
    label: 'brands.verticalOptions.hospitality',
  },
  FINANCIAL: {
    value: 'FINANCIAL',
    label: 'brands.verticalOptions.financial',
  },
  GAMBLING: {
    value: 'GAMBLING',
    label: 'brands.verticalOptions.gambling',
  },
  CONSTRUCTION: {
    value: 'CONSTRUCTION',
    label: 'brands.verticalOptions.construction',
  },
  NGO: {
    value: 'NGO',
    label: 'brands.verticalOptions.ngo',
  },
  MANUFACTURING: {
    value: 'MANUFACTURING',
    label: 'brands.verticalOptions.manufacturing',
  },
  GOVERNMENT: {
    value: 'GOVERNMENT',
    label: 'brands.verticalOptions.government',
  },
  TECHNOLOGY: {
    value: 'TECHNOLOGY',
    label: 'brands.verticalOptions.technology',
  },
  COMMUNICATION: {
    value: 'COMMUNICATION',
    label: 'brands.verticalOptions.communication',
  },
  HUMAN_RESOURCES: {
    value: 'HUMAN_RESOURCES',
    label: 'brands.verticalOptions.hr'
  },
  LEGAL: {
    value: 'LEGAL',
    label: 'brands.verticalOptions.legal'
  },
  POSTAL: {
    value: 'POSTAL',
    label: 'brands.verticalOptions.postal'
  },
  PROFESSIONAL: {
    value: 'PROFESSIONAL',
    label: 'brands.verticalOptions.professional'
  },
  TRANSPORTATION: {
    value: 'TRANSPORTATION',
    label: 'brands.verticalOptions.transportation'
  },
  EDUCATION: {
    value: 'EDUCATION',
    label: 'brands.verticalOptions.education'
  },
  ENERGY: {
    value: 'ENERGY',
    label: 'brands.verticalOptions.energy'
  }
};

const NON_QUICKFLOW_VERTICALS = ["NGO", "GOVERNMENT", "POLITICAL"];

export { BRAND_STATUSES, BUSINESS_ID_TYPES, ENTITY_TYPES, STOCK_EXCHANGE_TYPES, VERTICALS, NON_QUICKFLOW_VERTICALS };
